import React, { useContext, useEffect, useState } from "react";
import Styles from "./JobCard.module.scss";

import { AllJobDetails } from "@vahak/core/dist/_services/careers.service";
import { getJobMetaInfo } from "../../util-methods";
import Skeleton from "react-loading-skeleton";
import { AppContext } from "@vahak/core/dist/app-context";

export interface JobCardProps {
    jobDetails: AllJobDetails;
    isLoading: boolean;
}

const JobCard = ({ jobDetails, isLoading }: JobCardProps) => {
    const { isMobile } = useContext(AppContext);

    const [parsedDetails, setParsedDetails] = useState<ReturnType<typeof getJobMetaInfo>>();
    useEffect(() => {
        if (jobDetails) {
            setParsedDetails(getJobMetaInfo(jobDetails?.custom_excerpt));
        }
    }, [jobDetails]);

    return (
        <div className={Styles.jobCardCol}>
            <div className={Styles.jobCard}>
                <h4>
                    {!isLoading ? (
                        <>
                            {jobDetails?.title} (<span> {parsedDetails?.experience} </span>)
                        </>
                    ) : (
                        <Skeleton width={isMobile ? "60vw" : "360px"} />
                    )}
                </h4>
                {!isLoading ? (
                    <>
                        <span>{parsedDetails?.qualification}</span> . <span>{parsedDetails?.type}, Bangalore</span>
                    </>
                ) : (
                    <Skeleton width={isMobile ? "75vw" : "420px"} />
                )}
            </div>
        </div>
    );
};

export default JobCard;
